import styled from "styled-components";

export const Main = styled.div`
  font-family: var(--font-default);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 100vh;
`;
